import { colors, ColorVariant, getRecipeColor, Icon, IconSize, Typography } from '@ui-components/neo.tax';
import { ReactComponent as ArrowRight } from '@ui-components/neo.tax/dist/icons/arrow-right-1.svg';

import { ProjectEligibilityContainer, StyledIcon, StyledStack } from './rd-project-eligibility.styled';

interface RdProjectEligibilityItemProps {
  variant: ColorVariant;
  onClick: () => void;
  title: string;
  subtitle: string;
  iconNode: React.ReactElement;
  borderBottom?: boolean;
  borderTop?: boolean;
  iconBgColor?: string;
  iconNodeSize?: IconSize;
}

export const RdProjectEligibilityItem = ({
  borderBottom,
  borderTop,
  iconBgColor,
  iconNode,
  iconNodeSize = 6,
  onClick,
  subtitle,
  title,
  variant,
}: RdProjectEligibilityItemProps): React.ReactElement => (
  <StyledStack
    alignItems="center"
    gap={4}
    paddingX={1}
    as="button"
    onClick={onClick}
    fullWidth
    $borderBottom={borderBottom}
    $borderTop={borderTop}
  >
    <StyledIcon
      variant="circular"
      colorVariant="none"
      size={10}
      nodeSize={iconNodeSize}
      node={iconNode}
      $bgColor={iconBgColor}
    />
    <ProjectEligibilityContainer direction="column" alignItems="start" justifyContent="space-between">
      <Typography fontSize="sm" fontWeight="medium" color={getRecipeColor(variant, 'whiteBg').text} textAlign="left">
        {title}
      </Typography>
      <Typography fontSize="sm" color={colors.gray[500]} textAlign="left">
        {subtitle}
      </Typography>
    </ProjectEligibilityContainer>
    <Icon colorVariant="none" size={5} nodeSize={2} node={<ArrowRight />} />
  </StyledStack>
);
